﻿import React from 'react';

import { Breadcrumb, Container } from 'react-bootstrap';

import 'components/BreadCrumbNavigation/bread-crumb-navigation.scss';

import { clipText } from 'utils';

export interface StageBreadCrumb<T> {
	text: string;
	to: T;
}

interface BreadCrumbNavigationProps<T> {
	breadCrumbs: StageBreadCrumb<T>[];
	handleBreadCrumbClick?: (currentBreadCrumb: StageBreadCrumb<T>) => void | undefined;
}

export function BreadCrumbNavigation<T>({
    breadCrumbs,
    handleBreadCrumbClick = undefined

}: BreadCrumbNavigationProps<T>) {

    return (
        <Container fluid>
            {breadCrumbs.length > 0 && (
                <Breadcrumb className="breadcrumb">
                    {breadCrumbs.map((breadCrumb, i) => (
                        <Breadcrumb.Item
                            active={i === breadCrumbs.length - 1}
                            as="h3"
                            key={breadCrumb.text + i}
                            onClick={() => handleBreadCrumbClick && handleBreadCrumbClick(breadCrumb)}
                            style={{ textDecoration: i !== breadCrumbs.length - 1 ? 'underline' : '' }}
                        >
                            {clipText(breadCrumb.text, 30)}
                        </Breadcrumb.Item>
                    ))}
                </Breadcrumb>
            )}
        </Container>
    );

}
